import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { UnmountClosed as Collapse } from 'react-collapse';


function DocketHeader({ open, data, lastUpdated }) {
  if (isEmpty(data.text)) {
    return null;
  }

  return (
    <Collapse isOpened={open}>
      <div id="docket-header" className="inside-block docket-header" key="docket-header">
        <div id="docket-header-content">
          <div className="header-timestamp">
            Docket Header Last Updated: { lastUpdated }
          </div>
          <div dangerouslySetInnerHTML={{ __html: data.text }} />
        </div>
      </div>
    </Collapse>
  );
}

DocketHeader.defaultProps = {
  data: {},
  lastUpdated: '',
};

DocketHeader.propTypes = {
  open: PropTypes.bool.isRequired,
  data: PropTypes.object,
  lastUpdated: PropTypes.string,
};

export default DocketHeader;



/** WEBPACK FOOTER **
 ** ./src/components/case/docket/DocketHeader.jsx
 **/